import { MolsonAccordion, MolsonBox, MolsonDivider } from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'
import type { ReactNode } from 'react'

type CustomAccordionProps = {
  children: (NonNullable<ReactNode> & ReactNode) | null
  title: string
}

export const CustomAccordion = ({ children, title }: CustomAccordionProps) => {
  const theme = molsonUseTheme()

  return (
    <MolsonBox
      sx={{
        '&:last-of-type .MuiAccordion-root:after': {
          display: 'none'
        },
        '.MuiAccordionSummary-content': {
          '& > div:first-of-type': {
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'wrap'
          }
        },
        backgroundColor: theme.palette.secondary.lavenderBlush,
        mb: 1,
        px: 4
      }}
    >
      <MolsonAccordion
        primaryTextSx={{
          color: theme.palette.primary.errorContent,
          fontWeight: 700
        }}
        sx={{
          '& .MuiButtonBase-root.MuiAccordionSummary-root': {
            minHeight: 0
          },
          '&:after': {
            display: 'none'
          },
          backgroundColor: theme.palette.secondary.lavenderBlush
        }}
        primaryText={title}
        primaryTextVariant="body1"
        size="sm"
        summaryIcon="ERROR_OUTLINE"
        summaryIconColor="error"
      >
        <MolsonDivider
          sx={{ borderColor: theme.palette.secondary.melon, mb: 3 }}
        />

        <MolsonBox sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {children}
        </MolsonBox>
      </MolsonAccordion>
    </MolsonBox>
  )
}
